<template>
  <div class="common_layout">
    <el-container>
      <el-aside :class="{ 'common_layout_aside': true, 'common_layout_aside_small': asideSmall }">
        <img src="../assets/img/layout/up.png" class="layout_aside_top" />
        <img src="../assets//img/layout/dow.png" class="layout_aside_dow" />
        <img src="../assets//img/layout/logo.png" class="layout_aside_logo" v-if="!asideSmall" />
        <img src="../assets//img/layout/logo-small.png" class="layout_aside_logo logo-small" v-else />
        <div class="common_layout_aside_ul" v-if="!asideSmall">
          <div :class="{ 'common_layout_aside_li': true, 'active': activeStore == x.path }" v-for="(x, i) in asideList" :key="i" @click="GoPath(x)">
            <div :class="['common_layout_aside_img', 'nav' + i]"></div>
            <div class="common_layout_aside_text">{{ x.name }}</div>
          </div>
        </div>
        <div class="common_layout_aside_ul" v-else>
          <div :class="{ 'common_layout_aside_li': true, 'active': activeStore == x.path, 'common_layout_aside_li_small': asideSmall, }"
               v-for="(x, i) in asideList" :key="i" @click="GoPath(x)" :title="x.name">
            <div :class="['common_layout_aside_img', 'nav' + i]"></div>
          </div>
        </div>
      </el-aside>
      <el-container>
        <el-header class="common_layout_header">
          <div :class="{ 'header_put-away': true, 'header_put-away_small': asideSmall }" @click="putAway"></div>
          <div class="layout_header_title">
            <p class="p1">不良信息上报系统 </p>
            <!-- <p class="p2">{{ user.dept.deptName }}</p> -->
          </div>
          <div class="layout_header_right">
            <div class="layout_user">
              <p class="p3">{{ user.nickName }}，欢迎登录!</p>
              <p class="p3">{{ time }}</p>
            </div>
            <img src="../assets/img/layout/out.png" class="layout_out" @click="out" />
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import index from "@/api/index/index.js";
import institution from "@/api/institution/index.js";
import publicOpinion from "@/api/publicOpinion/index.js";

export default {
  data() {
    return {
      activeStore: this.$route.meta.activePath,
      asideList: [
        { name: "首页", path: "/index" },
        { name: "舆情发现", path: "/publicOpinion" },
        { name: "上报人员", path: "/sentinelUser" },
        { name: "机构管理", path: "/institutionIndex" },
        { name: "考核统计", path: "/examineStatistics" },
        { name: "区域考核统计", path: "/areaStatistics" },
        { name: "机构考核统计", path: "/institutionStatistics" },
        { name: "人员考核统计", path: "/userStatistics" },
        { name: "基本信息", path: "/basicInformation" }
      ],
      asideSmall: false,
      time: "0000年00月00日 00:00:00",
      user: JSON.parse(sessionStorage.getItem("user")) || {}
    };
  },
  watch: {
    $route(to) {
      this.activeStore = to.meta.activePath;
    },
  },
  methods: {
    GoPath(value) {
      this.activeStore = value.path;
      this.$router.push(value.path);
    },
    putAway() {
      this.asideSmall = !this.asideSmall;
      sessionStorage.setItem("asideSmall", this.asideSmall);
    },
    async out() {
      this.$messageBox.confirm(
        '是否确认退出?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(async () => {
          let res = await index.logout()
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '退出成功!'
            });
            sessionStorage.clear();
            this.$router.push("/login");
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })

    },
    pad(val, len) {
      val = String(val);
      len = len || 2;
      while (val.length < len) {
        val = '0' + val;
      }
      return val;
    },
    getTime() {
      this.time = this.$main.timeCycle(new Date(), 'yyyy年MM月dd日 HH:mm:ss');
      setTimeout(() => { this.getTime() }, 1000);
    },
    async deptList() {
      let res = await index.deptList({ organId: this.user?.organId });
      // 首次直接把接口数据存放到store中,数据刷新丢失
      this.$store.state.institutionList = res.data;
      // 刷新之后获取数据
      sessionStorage.setItem("institutionList", JSON.stringify(res.data));
    },
    async allAreaInfo() {
      let res = await index.allAreaInfo();
      this.$store.state.areaInfoList = res.data;
      sessionStorage.setItem("areaInfoList", JSON.stringify(res.data));
    },
    async allInfoType() {
      let res = await index.allInfoType();
      this.$store.state.inforTypeList = res.data;
      sessionStorage.setItem("inforTypeList", JSON.stringify(res.data));
    },
    async allPlatFormSource() {
      let res = await index.allPlatFormSource();
      this.$store.state.platFormSourceList = res.data;
      sessionStorage.setItem("platFormSourceList", JSON.stringify(res.data));
    },
    async getDeptAreaList() {
      let res = await institution.getDeptAreaList();
      this.$store.state.deptAreaList = res.data;
      sessionStorage.setItem("deptAreaList", JSON.stringify(res.data));
    },
    async allAuditor() {
      let res = await publicOpinion.allAuditor();
      this.$store.state.allAuditor = res.data;
      sessionStorage.setItem("allAuditor", JSON.stringify(res.data));
    },
  },
  created() {
    this.asideSmall = sessionStorage.getItem("asideSmall") == 'true' ? true : false;
    this.getTime();
    this.deptList();
    this.allAreaInfo()
    this.allInfoType()
    this.allPlatFormSource()
    this.getDeptAreaList()
    this.allAuditor()
  },
  mounted() { },
};
</script>

<style scoped>
.common_layout {
  width: 100%;
  height: 100%;
}

.common_layout_aside {
  position: relative;
  width: 2.28rem;
  height: 100%;
  min-height: 3.5rem;
  background: linear-gradient(180deg, #dae8ff 0%, #ffffff 100%);
}

.layout_aside_top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.layout_aside_dow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.layout_aside_logo {
  width: 1.3rem;
  margin-top: 0.45rem;
  margin-left: 0.46rem;
  margin-bottom: 0.45rem;
}

.common_layout_aside_ul {
  overflow-y: auto;
  height: calc(100% - 1.2rem);
}

.common_layout_aside_li {
  width: 1.8rem;
  height: 0.48rem;
  margin-left: 0.24rem;
  border-radius: 0.08rem;
  cursor: pointer;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  padding-left: 0.2rem;
}

.common_layout_aside_li + .common_layout_aside_li {
  margin-top: 0.23rem;
}

.common_layout_aside_li:hover {
  opacity: 0.8;
}

.common_layout_aside_img {
  width: 0.3rem;
  height: 0.3rem;
  background-image: url(../assets/img/layout/aside.png);
  background-position: 0 0;
  background-size: 0.6rem 3rem;
}

.common_layout_aside_text {
  font-size: 0.16rem;
  color: #333;
  font-weight: bold;
  line-height: 1;
  margin-left: 0.15rem;
}

.common_layout_aside_li .nav0 {
  background-position: 0 0;
}

.common_layout_aside_li .nav1 {
  background-position: 0 -0.3rem;
}

.common_layout_aside_li .nav2 {
  background-position: 0 -0.6rem;
}

.common_layout_aside_li .nav3 {
  background-position: 0 -0.9rem;
}

.common_layout_aside_li .nav4 {
  background-position: 0 -1.2rem;
}

.common_layout_aside_li .nav5 {
  background-position: 0 -1.5rem;
}

.common_layout_aside_li .nav6 {
  background-position: 0 -1.8rem;
}

.common_layout_aside_li .nav7 {
  background-position: 0 -2.1rem;
}

.common_layout_aside_li.active {
  background: linear-gradient(129deg, #5b7cf4 0%, #72a9f7 100%);
}

.common_layout_aside_li.active .common_layout_aside_text {
  color: #fff;
}

.common_layout_aside_li.active .nav0 {
  background-position: 0.3rem 0;
}

.common_layout_aside_li.active .nav1 {
  background-position: 0.3rem -0.3rem;
}

.common_layout_aside_li.active .nav2 {
  background-position: 0.3rem -0.6rem;
}

.common_layout_aside_li.active .nav3 {
  background-position: 0.3rem -0.9rem;
}

.common_layout_aside_li.active .nav4 {
  background-position: 0.3rem -1.2rem;
}

.common_layout_aside_li.active .nav5 {
  background-position: 0.3rem -1.5rem;
}

.common_layout_aside_li.active .nav6 {
  background-position: 0.3rem -1.8rem;
}

.common_layout_aside_li.active .nav7 {
  background-position: 0.3rem -2.1rem;
}

.common_layout_header {
  height: 0.88rem;
  background: linear-gradient(129deg, #5b7cf4 0%, #72a9f7 100%);
  padding: 0;
}

.header_put-away {
  width: 0.92rem;
  height: 100%;
  background: url(../assets/img/layout/put-away.png) no-repeat center center;
  background-size: 0.28rem 0.24rem;
  cursor: pointer;
  border-right: 0.01rem solid #fff;
  float: left;
}

.header_put-away_small {
  transform: rotate(180deg);
  border-left: 0.01rem solid #fff;
  border-right: none;
}

.common_layout_aside_small {
  width: 0.96rem;
}

.logo-small {
  width: 0.47rem;
  height: 0.3rem;
  margin-left: 0.24rem;
}

.common_layout_aside_li_small {
  width: 0.48rem;
  padding-left: 0.09rem;
}

.layout_header_title {
  margin-left: 0.32rem;
  float: left;
}

.p1 {
  font-family: "fz";
  font-size: 0.3rem;
  color: #ffffff;
  line-height: 0.88rem;
}

.p2 {
  font-size: 0.14rem;
  color: #ffffff;
}

.layout_header_right {
  float: right;
  height: 100%;
  padding-right: 0.33rem;
  display: flex;
  align-items: center;
}

.layout_user {
  font-size: 0.14rem;
  color: #ffffff;
  line-height: 1;
}

.p3 {
  line-height: 1;
  text-align: right;
  margin-right: 0.33rem;
}

.p3 + .p3 {
  margin-top: 0.04rem;
}

.layout_out {
  cursor: pointer;
  width: 0.3rem;
  height: 0.3rem;
}
</style>
